// Angular
import { Component, OnInit } from '@angular/core';
// Services
import { ElasticService } from '../../services/elastic';
// External
import * as lodash from 'lodash';
import { ActivatedRoute } from '@angular/router';

import { ApiService } from '../../services/api';
import { AngularFireAuth } from 'angularfire2/auth';

@Component({
    templateUrl: './entry.notification.component.html'
})
export class EntryNotificationComponent implements OnInit {
    public tournamentId: string;
    public enteries: Array<any>;
    public filterargs = { fullName: "" }
    public selectAll = false
    public notify = {
        body: "New ",
        title: "Golfhubber",
        users: {},
        type: 18,
        cid: "",
        tournament: ""
    }
    constructor(private elasticService: ElasticService, private fireAuth: AngularFireAuth, private route: ActivatedRoute, private apiService: ApiService) {

    }

    ngOnInit() {
        this.tournamentId = this.route.snapshot.paramMap.get('id');
        this.notify = {
            body: "",
            title: "Golfhubber",
            users: {},
            type: 18,
            cid: "",
            tournament: this.tournamentId

        }
        this.apiService.object(`/tournaments/${this.tournamentId}`)
            .then(tournamnet => {

                this.getTournamentEnteries(tournamnet)


                this.apiService.object(`/users/${tournamnet.cid}`)
                    .then(club => {
                        this.notify.title = "New message from Golfhubber"
                        this.notify.cid = tournamnet.cid
                    });
            })
    }

    getTournamentEnteries(tournament) {
        this.enteries = []
        console.log(tournament)
        if (tournament.enteries) {
            lodash.forEach(tournament.enteries, (item, key) => {
                this.apiService.object(`/users/${key}`)
                    .then(user => {
                        user.isSelected = false
                        user.key = key
                        this.enteries.push(user)
                    });
            })
        }
    }

    public enterieselect(event, offer) {

        if (event) {
            offer.isSelected = true;
            var i = -1;
            for (i = 0; i < this.enteries.length; i++) {
                if (this.enteries[i].isSelected == false) {
                    break;
                }
            }
            if (i != -1 && i != this.enteries.length) {
                this.selectAll = false;
            } else {
                this.selectAll = true;
            }

        } else {
            offer.isSelected = false;
            this.selectAll = false;

        }
        // console.log(event)
        // console.log(offer)
    }
    public selectAllOffer(event) {
        if (event) {
            lodash.forEach(this.enteries, (item, key) => {
                // console.log(item)
                item.isSelected = true;
            })
        } else {
            lodash.forEach(this.enteries, (item, key) => {
                // console.log(item)
                item.isSelected = false;
            })
            this.selectAll = false
        }

    }

    public send() {
        var count = 0
        lodash.forEach(this.enteries, (item, key) => {
            if (item.isSelected) {
                this.notify.users[item.key] = true
                ++count;
            }
        })
        console.log(this.notify)
        if(count==0){
            alert("Please select atleast one player")

        }
        if (this.notify.body != "" && count > 0) {
            this.apiService.set("/server-process/admin-notification/" + (new Date().getTime()) + "/" + this.fireAuth.auth.currentUser.uid, this.notify).then((res) => {
                this.selectAllOffer(false)
                this.notify.body = ""
                this.selectAll = false
                alert("Message sent successfully!")
            })

        }

    }
}
